import { render, staticRenderFns } from "./TeamSite.vue?vue&type=template&id=6e70a54f&scoped=true&"
import script from "./TeamSite.vue?vue&type=script&lang=ts&"
export * from "./TeamSite.vue?vue&type=script&lang=ts&"
import style0 from "./TeamSite.vue?vue&type=style&index=0&id=6e70a54f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e70a54f",
  null
  
)

export default component.exports